import createSvgIcon from "./utils/create_icon"

const ChevronRightLarge = createSvgIcon(<path clipRule="evenodd" d="M7.293 3.293a1 1 0 0 1 1.414 0l8 8a1 1 0 0 1 0 1.414l-8 8a1 1 0 0 1-1.414-1.414L14.586 12 7.293 4.707a1 1 0 0 1 0-1.414z" fill="currentColor" fillRule="evenodd" />, "ChevronRightLarge")
export default ChevronRightLarge
